import { useToast as useToastPrimitive } from '@/lib/hooks/use-toast'

interface ToastOptions {
  title: string
  description?: string
  variant?: 'default' | 'destructive' | 'success' | 'warning'
}

export const useToast = () => {
  const { toast: toastPrimitive } = useToastPrimitive()

  const toast = (options: ToastOptions) => {
    return toastPrimitive({
      title: options.title,
      description: options.description,
      variant: options.variant,
    })
  }

  return { toast }
}
